mainApp.directive('sitesDropDown', function() {
    return {
        templateUrl: '/public/directives/SitesDropDown.html',
        scope: {
            entitieslist: "=?",
            selectedentities: "=?",
            recententities: "=?",
            entities: "=?"
        },
        controller: ["$scope", '$filter', function($scope, $filter) {
            $scope.chooseSite = function(entity){
                var stringId = entity.id.toString();

                if(stringId === "0"){
                    $scope.selectedentities = [];
                }
                else {
                    if($scope.selectedentities.indexOf(stringId) > -1){
                        $scope.selectedentities.splice($scope.selectedentities.indexOf(stringId), 1);
                    }
                    else {
                        $scope.selectedentities.push(stringId);
                    }
                }

            };


            $scope.filter = function(filterBy){
                $scope.entitieslist = _.filter($scope.entities, filterBy);
            };

            $scope.filterList = function(filterBy){
                switch (filterBy) {
                    case 'recent':
                        $scope.entitieslist = _.filter($scope.entities, function(n){
                            if(n.type === "group"){
                                return $scope.recententities.indexOf("g" + n.id) != -1
                            }
                            else if(n.type === "user"){
                                return $scope.recententities.indexOf("u" + n.id) != -1
                            }
                            else if(n.type === "site"){
                                return $scope.recententities.indexOf("s" + n.id) != -1
                            }

                        });
                        $('.sites-filter .current').removeClass('current');
                        $('.sites-filter .recent').addClass('current');
                        break;
                    default:
                        $scope.entitieslist = $scope.entities;
                        $('.sites-filter .current').removeClass('current');
                        $('.sites-filter .all').addClass('current');
                        break;
                }
            };

            $scope.filterListType = function(filterBy){
                switch (filterBy) {
                    case 'groups':
                        $scope.entitieslist = _.filter($scope.entities, function(n){
                            return n.type === "group";
                        });
                        $('.entities-types .current').removeClass('current');
                        $('.entities-types .groups').addClass('current');
                        break;
                    case 'sites':
                        $scope.entitieslist = _.filter($scope.entities, function(n){
                            return n.type === "site";
                        });
                        $('.entities-types .current').removeClass('current');
                        $('.entities-types .sites').addClass('current');
                        break;
                    case 'users':
                        $scope.entitieslist = _.filter($scope.entities, function(n){
                            return n.type === "user";
                        });
                        $('.entities-types .current').removeClass('current');
                        $('.entities-types .users').addClass('current');
                        break;
                    default:
                        $scope.entitieslist = $scope.entities;
                        $('.entities-types .current').removeClass('current');
                        $('.entities-types .all').addClass('current');
                        break;
                }
            };

            var $search = $('#entities-selector-search');
            $scope.toggleSearchFocus = function(){
                if($search.val() === ''){
                    $('.has-feedback').toggleClass("showClass");
                }
            };

            $scope.search = function(){
                var searchString = $search.val();
                if(searchString === ''){
                    $scope.entitieslist = $scope.entities;
                }
                else {
                    searchString = $filter('lowercase')(searchString);
                    $scope.entitieslist = _.filter($scope.entities, function(n){
                        return  $filter('lowercase')(n.name).indexOf(searchString) !== -1
                    });
                }

                $('.entities-types .current').removeClass('current');
                $('.entities-types .all').addClass('current');
            }
        }]
    }
});